import React, { useEffect, useState } from "react";
import { Field, Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import { post } from "../../../helpers/api_helper";
import {
  POST_EmailConfigurationInsert,
  POST_EmailConfigurationUpdate,
  POST_EmailSettingsVerification,
} from "../../../helpers/url_helper";
import swal from "sweetalert";
import {
  errorMessage,
  successMessage,
  validateEmailField,
} from "../CommonFunctions";

const EmailSettings = ({ EmailType, setIsLoading, data }) => {
  /*
    EmailType :
        1 = Inward
        2 = Dispatch Report
        3 = Upload Scan Copy
        4 = Invoice
        5 = Broadcast Message
        6 = Machine Calibration
    */
  const [isPasswordNew, setIsPasswordNew] = useState(true);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    SMTPServerName: Yup.string()
      .trim()
      .required("SMTP Server is required field"),
    SMTPPassword: Yup.string().required("Password is required field"),
    ReTypePassword: Yup.string()
      .oneOf([Yup.ref("SMTPPassword"), null], "Passwords must match")
      .required("Re-Type Password is required field"),
    SMTPUserName: Yup.string().trim().required("User Name is required field"),
    SMTPPort: Yup.string().trim().required("SMTP Port is required field"),
    SMTPFromEmailID: Yup.string()
      .trim()
      .required("From Email is required field"),
    DisplayName: Yup.string().trim().required("Display Name is required field"),
    // AdminEmailID: Yup.string().trim().required("Admin Email is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      EmailConfigurationIDEncrypt: "",
      SMTPServerName: "",
      SMTPPassword: "",
      ReTypePassword: "",
      SMTPUserName: "",
      SMTPPort: "",
      SMTPEnableSSL: false,
      SMTPFromEmailID: "",
      DisplayName: "",
      AdminEmailID: "",
      submitType: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { EmailConfigurationIDEncrypt, SMTPEnableSSL, submitType },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);

    let payload = {
      ...values,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      EmailType: EmailType,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    if (submitType == "Verify") {
      post(POST_EmailSettingsVerification, payload)
        .then((response) => {
          setIsLoading(true);
          if (response?.IsSuccess) {
            // swal("Success!", response?.Message, "success");
            successMessage(response?.Message);
          } else {
            // swal("Error!", response?.Message, "error");
            errorMessage(response?.Message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      post(
        EmailConfigurationIDEncrypt
          ? POST_EmailConfigurationUpdate
          : POST_EmailConfigurationInsert,
        payload
      )
        .then((response) => {
          setIsLoading(true);
          if (response?.IsSuccess) {
            formik.setFieldValue(
              "EmailConfigurationIDEncrypt",
              response?.EncryptID
            );

            var obj = JSON.parse(localStorage.getItem("userDetails"));
            if (EmailType == 1) {
              obj.IsInwardEmailSetup = true;
            } else if (EmailType == 2) {
              obj.IsDispatchReportEmailSetup = true;
            } else if (EmailType == 3) {
              obj.IsUploadScanCopyEmailSetup = true;
            } else if (EmailType == 4) {
              obj.IsInvoiceEmailSetup = true;
            } else if (EmailType == 5) {
              obj.IsBroadcastEmailSetup = true;
            } else if (EmailType == 6) {
              obj.IsMachineCalibrationEmailSetup = true;
            }
            localStorage.setItem("userDetails", JSON.stringify(obj));

            // swal("Success!", response?.Message, "success");
            successMessage(response?.Message);
          } else {
            // swal("Error!", response?.Message, "error");
            errorMessage(response?.Message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (data) {
      formik.setValues({ ...data, ReTypePassword: "" });
    }
  }, [data]);

  return (
    <>
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <Col lg={3}>
              <Field
                label="SMTP Server"
                name="SMTPServerName"
                placeholder={"Enter SMTP Server"}
                component={CustomInput}
                required
                maxLength={150}
                autoFocus
              />
            </Col>
            <Col lg={3}>
              <Field
                type="number"
                label="SMTP Port"
                name="SMTPPort"
                placeholder={"Enter SMTP Port"}
                component={CustomInput}
                required
              />
            </Col>
            <Col lg={3}>
              <label className="mb-1">Enable SSL</label>
              <div className="mb-2 form-control form-control-sm">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="SMTPEnableSSL"
                  name="SMTPEnableSSL"
                  checked={SMTPEnableSSL}
                  onChange={(e) => {
                    formik.setFieldValue("SMTPEnableSSL", e.target.checked);
                  }}
                />
                <label className="form-check-label" htmlFor="SMTPEnableSSL">
                  Enable SSL
                </label>
              </div>
            </Col>
            <Col lg={3}>
              <Field
                type="email"
                label="From Email"
                name="SMTPFromEmailID"
                placeholder={"Enter From Email"}
                component={CustomInput}
                required
                maxLength={150}
                validate={validateEmailField}
              />
            </Col>
            <Col lg={3}>
              <Field
                label="User Name"
                name="SMTPUserName"
                placeholder={"Enter User Name"}
                component={CustomInput}
                required
                maxLength={150}
              />
            </Col>
            <Col lg={3}>
              <Field
                type={isPasswordNew ? "password" : "text"}
                label="Password"
                name="SMTPPassword"
                placeholder={"Enter Password"}
                component={CustomInput}
                passwordEye={true}
                setIsPassword={setIsPasswordNew}
                required
                maxLength={250}
              />
            </Col>
            <Col lg={3}>
              <Field
                type="password"
                label="Re-Type Password"
                name="ReTypePassword"
                placeholder={"Re-Type Password"}
                component={CustomInput}
                required
                maxLength={250}
              />
            </Col>
            <Col lg={3}>
              <Field
                label="Display Name"
                name="DisplayName"
                placeholder={"Enter Display Name"}
                component={CustomInput}
                required
                maxLength={150}
              />
            </Col>
            <Col lg={3}>
              <Field
                type="email"
                label="Admin Email"
                name="AdminEmailID"
                placeholder={"Enter Admin Email"}
                component={CustomInput}
                maxLength={150}
                validate={validateEmailField}
              />
            </Col>
          </Row>
          <hr className="mt-1 mb-2"></hr>
          <button
            type="submit"
            className="btn btn-success btn-sm me-2"
            onClick={(e) => {
              formik.setFieldValue("submitType", "Verify");
            }}
          >
            <i className="fa-solid fa-circle-check"></i> Verify Email
          </button>
          <button
            type="submit"
            // className="btn btn-primary"
            className="btn btn-primary btn-sm me-2"
            onClick={(e) => {
              formik.setFieldValue("submitType", "Submit");
            }}
          >
            <i className="fa-solid fa-floppy-disk"></i> Submit
          </button>
        </Form>
      </FormikProvider>
    </>
  );
};

export default EmailSettings;
